module.exports = __webpack_public_path__ + "img/printer.86c5301d.svg";